import { ProductSpec } from "../interface"

export const powerArqS7: ProductSpec = {
  id: 'pa70',
  name: 'PowerArQ S7',
  url: process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? "https://item.rakuten.co.jp/kashima-tokeiten/pa70/" : "https://powerarq.com/collections/frontpage/products/pa70",
  capacity: 716,
  colors: [
    'coyote-tan',
    'olive-drab',
  ],
  defaultColor: 'olive-drab',
  price: 88000,
  description: 'シリーズ初の700Wモデル。リン酸鉄リチウムイオンバッテリーのため、充放電を3,000 回以上繰り返し利用することが可能。ワイヤレス充電やLEDライトも実装。',
  chargingTime: 4,
  chargingTimeWithSolar: { input: 150, value: 6 },
  chargingTimeWithCar: { input: 80, value: 8.5 },
  batteryType: 'リン酸鉄',
  maximumOutput: 700,
  smartphone: 61,
  electricBlanket: 12,
  fan: 20,
  ledLight: 203,
  riceCooker: 2,
  fridge: 10,
  electricCarpet: 3,
  electricPod: 1,
  acPort: 5,
  usbA: 2,
  usbC: 2,
  qi: 1,
  builtInLed: 500,
  weight: 7.9
}